<mf-page title="Crear valor de lista administrable">
  <mf-admin-value-list
    (close)="close()"
    #valueListComponent
    (save)="submit($event)" />
</mf-page>
